export default theme => ({
  formControl: {
    margin: theme.spacing(1),
    width: 'auto',
  },
});

